export default "__VITE_ASSET__Daab_dx$__"